<template>
  <div>

    <!-- Pagination -->
    <!-- <div class="d-flex justify-content-end align-items-center mb-2">

      <img
        alt="left"
        width="16"
        src="@/assets/icons/left-2.svg"
        class="mr-2"
        style="cursor: pointer;"
        @click="previousPage"
        :style="{ opacity: pageChart === 1 ? 0.5 : 1, pointerEvents: pageChart === 1 ? 'none' : 'auto' }"
      />

      <span class="small mr-2">page {{ pageChart }}</span>

      <img
        alt="right"
        width="16"
        src="@/assets/icons/right-2.svg"
        style="cursor: pointer;"
        @click="nextPage"
      />

    </div> -->

    <!-- Chart -->
    <apexchart
      ref="apexchart"
      :key="apexChartsBarArea"
      v-if="chartOptions && chartOptions.series && chartOptions.series.length"
      type="bar"
      height="400"
      :options="chartOptions"
      :series="chartOptions.series"
    />

  </div>
</template>

<script>
import ReportingApi from "@/services/reporting-api";

export default {
  props: {
    campaignId: Number,
    range: Object
  },

  data() {
    return {
      chartOptions: {},
      apexChartsBarArea: 0,
      pageChart: 1,
      pageSize: 24
    };
  },

  mounted() {
    this.getOrderPerformanceData();
  },

  watch: {
    pageSize() {
      this.pageChart = 1;
      this.getOrderPerformanceData();
    },

    campaignId:function(){
      this.pageChart = 1;
      this.getOrderPerformanceData()
    },

    range: {
      handler(newVal) {
        if (newVal?.startDate && newVal?.endDate) {
          this.getOrderPerformanceData();
        }
      },
      deep: true,
      immediate: false
    }
  },

  methods: {

    // API CALL

    
    getOrderPerformanceData() {

      if(!this.range || !this.range.startDate || !this.range.endDate){
        return;
      } 

      const params = {
        page: this.pageChart,
        pageSize: this.pageSize,
        campaignId: this.campaignId,
        start: this.range.startDate,
        end: this.range.endDate
      };


      ReportingApi.getHourlyScanDashboardStats(params).then((result) => {
        if (result) {
          this.orderPerformanceChartKey++;
          this.renderChart(result);

        }
      });

    },

    nextPage() {
      this.pageChart++;
      this.getOrderPerformanceData();
    },

    previousPage() {
      if (this.pageChart > 1) {
        this.pageChart--;
        this.getOrderPerformanceData();
      }
    },

    renderChart(data) {
      this.chartOptions = {
        series: [
          {
            name: "",
            data: data.count
          }
        ],

        chart: {
          type: "bar",
          height: 140,
          toolbar: { show: false }
        },

        plotOptions: {
          bar: {
            columnWidth: "70%",
            borderRadius: 6,
            borderRadiusApplication: "end",
            endingShape: "rounded"
          }
        },

        colors: ["#d6d8f7"],

        dataLabels: {
          enabled: false
        },

        stroke: {
          show: true,
          width: 1,
          colors: ['#dcdef8']
        },


        xaxis: {
          categories: data.labels.map(h => `${h}h`),
          labels: {
            style: {
              colors: "#94a3b8",
              fontSize: "11px"
            }
          },
          axisBorder: { show: false },
          axisTicks: { show: false }
        },

        yaxis: {
          show: false
        },

        grid: {
          show: false
        },

        tooltip: {
          y: {
            formatter: (val) => Math.round(val) + " Scan(s)"
          }
        }
      };

      this.apexChartsBarArea++;
    }
  }
};
</script>
